export const EMPTY_FORM_STATE = {
  language: "",
  academicCareer: "",
  attribute: "",
  classes: "",
  year: "",
  board: "",
  stream: "",
  courses: [],
  materialInfo: [],
};

export const DEFAULT_FILTER_STATE = {
  academicCareer: [],
  classes: [],
  attribute: [],
  language: [],
  board: "",
  stream: "",
};

export const NEW_EMPTY_MATERIAL_ROW = {
  packageCodeId: "",
  materialIds: [],
  isNew: true,
};

export const SEARCH_BY = [
  {
    key: "courseId",
    value: "By Course ID",
  },
  {
    key: "materialId",
    value: "By Material ID",
  },
];

export const MAPPING_YEAR_DROPDOWN = [
  { label: "Year 1", value: "Year 1" },
  { label: "Year 2", value: "Year 2" },
  { label: "Year 3", value: "Year 3" },
  { label: "Year 4", value: "Year 4" },
  { label: "Year 5", value: "Year 5" },
];

export const InputCustomIconStyles = {
  fontSize: "12px",
  position: "absolute",
  bottom: "7px",
  right: "113px",
  margin: "auto",
};

export const DropdownSearchInputStyles = {
  position: "absolute",
  bottom: "0",
  margin: "auto 0",
  background: "#FFF6E3",
  color: "#A17217",
  border: "none",
};

export const inputHeight = "42px";
